import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  HorizontalLine,
  TableHeaderCell,
  TakedownTable,
} from '../../pages/ThreadsDetails/Style/SingleThreat.style';
import { SectionColumn, SectionTitle } from '../ThreatTable/ThreatExpandedRow.style';
import { formatedDate } from '../../utils';

interface ExpandedTakedownDetailsProps {
  takedownItems: any[] | undefined;
  takedownLoading: boolean;
  findStatusNameById: (id: number) => string;
}

const ExpandedTakedownDetails = ({
  takedownItems,
  takedownLoading,
  findStatusNameById,
}: ExpandedTakedownDetailsProps) => {
  const theme = useTheme();

  return (
    <SectionColumn>
      <SectionTitle>Takedown Details</SectionTitle>
      <HorizontalLine sx={{ mb: 1 }} />
      {takedownLoading ? (
        <Skeleton variant="rectangular" height={80} />
      ) : takedownItems && takedownItems.length > 0 ? (
        <TakedownTable>
          <TableContainer sx={{ maxHeight: 150 }}>
            <Table size="small" sx={{ border: 0 }}>
              <TableHead>
                <TableRow>
                  <TableHeaderCell>Status</TableHeaderCell>
                  <TableHeaderCell>Created</TableHeaderCell>
                  <TableHeaderCell>Updated</TableHeaderCell>
                  <TableHeaderCell>Message</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {takedownItems.map((item: any, index: number) => (
                  <TableRow key={index} sx={{ '&:last-child td': { border: 0 } }}>
                    <TableCell sx={{ fontSize: '12px', textTransform: 'capitalize' }}>
                      {findStatusNameById(item.status_id)}
                    </TableCell>
                    <TableCell sx={{ fontSize: '12px' }}>
                      {`${formatedDate(item.created)} UTC`}
                    </TableCell>
                    <TableCell sx={{ fontSize: '12px' }}>
                      {`${formatedDate(item.updated_at)} UTC`}
                    </TableCell>
                    <TableCell sx={{ fontSize: '12px' }}>{item.description || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TakedownTable>
      ) : (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.disabled, fontStyle: 'italic' }}>
          No takedowns
        </Typography>
      )}
    </SectionColumn>
  );
};

export default ExpandedTakedownDetails;
